import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useViewport } from "src/common/hooks/ViewPort";
import ProfileCard, {
  buildStats,
} from "src/components/atoms/ProfileCard/ProfileCard";
import mePng from "../../styles/assets/img/icon_yellow.png";

import plusIcon from "../../styles/assets/svg/icon_sets.svg";
import { ConnectedFamilyCard } from "src/components/atoms/ConnectedFamilyCard/ConnectedFamilyCard";
import Toast from "./components/InfoToast";
import { PageContainer } from "src/components/organisms/contents";
import { useUserRegister } from "src/common/hooks/useUserRegister";
import { useFamilyRegister } from "src/common/hooks/userFamilyRegister";
import { formatBirthday } from "src/common/hooks/useFormatBirthDay";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import packageJson from "../../../package.json";

export const MyInfoPage = () => {
  const navi = useNavigate();
  const location = useLocation() as { state?: { toast?: string } };

  const { px } = useViewport();

  const [toast, setToast] = useState<string | null>(null);

  // 유저 정보 불러오기
  const { data: userInfo } = useUserRegister();

  // 가족 정보 불러오기
  const { data: familyInfo = [] } = useFamilyRegister();

  useEffect(() => {
    if (location.state?.toast) {
      setToast(location.state.toast);
      navi(".", { replace: true, state: {} });
    }
  }, [location.state, navi]);

  const genderRender = () => {
    if (userInfo?.gender === "M") return "남자";
    else return "여자";
  };

  return (
    <PageContainer isNavBar={true} active="myinfo">
      <>
        {/* 헤더 */}
        <SubConHeader title="내 정보" onClickArrow={() => navi("/")} />

        <div style={{ paddingBottom: "80px" }}>
          {/* 프로필 카드 */}
          {userInfo && (
            <ProfileCard
              name={userInfo?.userName || ""}
              subinfo={`${userInfo?.birthyear}.${formatBirthday(
                userInfo?.birthday
              )} | ${genderRender()}`}
              imgSrc={
                userInfo?.profileImage?.startsWith("http")
                  ? userInfo.profileImage
                  : userInfo?.profileImage === "" ||
                    userInfo?.profileImage === null
                  ? mePng
                  : process.env.REACT_APP_API_FILE! + userInfo?.profileImage
              }
              stats={buildStats([24, 156, 8])}
              relation="self"
              onManage={() => navi("/mysetting")}
              px={px}
            />
          )}

          <div style={{ marginTop: px(16) }}>
            <ConnectedFamilyCard
              members={familyInfo || []}
              count={familyInfo?.length || 0}
              px={px}
              showChevron
              onChevronClick={() =>
                familyInfo?.length > 0
                  ? navi("/myinfo/family")
                  : navi("/myinfo/invite")
              }
              showAddButton
              onAdd={() => navi("/myinfo/invite")}
              addIconSrc={plusIcon}
            />
          </div>

          {/* 메뉴 리스트 */}
          <section
            style={{
              marginTop: px(16),
              background: "#FFFFFF",
              borderRadius: px(16),
              boxShadow: "0px 4px 11px rgba(0,0,0,0.04)",
              outline: `1px solid #E5E5E5`,
              outlineOffset: "-1px",
              overflow: "hidden",
            }}
          >
            <RowButton
              label="고객센터"
              onClick={() => navi("/service")}
              px={px}
            />
            {/* <div style={{ height: 1, background: "#E5E5E5" }} /> */}
            <RowButton
              label="약관 및 정책"
              onClick={() => navi("/policy")}
              px={px}
            />
          </section>

          {/* 버전 */}
          <div
            style={{
              color: "#A3A3A3",
              fontSize: px(14),
              fontWeight: 500,
              lineHeight: "20px",
              marginTop: px(8),
              paddingLeft: px(2),
            }}
          >
            버전 {packageJson.version}
          </div>
        </div>

        <Toast
          message={toast ?? ""}
          open={!!toast}
          px={px}
          onClose={() => setToast(null)}
        />
      </>
    </PageContainer>
  );
};

const RowButton: React.FC<{
  label: string;
  onClick: () => void;
  px: (n: number) => number;
}> = ({ label, onClick, px }) => (
  <button
    onClick={onClick}
    style={{
      width: "100%",
      height: px(52),
      padding: `0 ${px(16)}px`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "#fff",
      border: "none",
      cursor: "pointer",
    }}
  >
    <span
      style={{
        fontSize: px(16),
        color: "#404040",
        fontWeight: 500,
        lineHeight: "24px",
      }}
    >
      {label}
    </span>
    <svg width={px(18)} height={px(18)} viewBox="0 0 24 24">
      <path
        d="M9 18l6-6-6-6"
        stroke="#9CA3AF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </button>
);
